import React from 'react'
import { Container, Row, Card, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const AboutUs = () => {
    return (<>
        <Container className='outerContainer'>
            <Row>
                <Col xs={12} md={6} className='stretchCard'>
                    <Card className="mb-4">
                        <Card.Img variant="top" src="/images/QIs-Overview.jpeg" />
                        <Card.Body>
                            <Card.Title>AHRQ QIs Overview</Card.Title>
                            <Link
                                className="btn btn-primary"
                                role="button"
                                to="../faqs?2#QIOverview-WhatAreQIs"
                            >
                                Learn More
                            </Link>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs={12} md={6}  className='stretchCard'>
                    <Card className="mb-4">
                        <Card.Img variant="top" src="/images/QI-Using.jpeg" />
                        <Card.Body>
                            <Card.Title>Using AHRQ QIs</Card.Title>
                            <Link
                                className="btn btn-primary"
                                role="button"
                                to="../faqs?3#UsingQI-FAQ70"
                            >
                                Learn More
                            </Link>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs={12} md={6}  className='stretchCard'>
                    <Card className="mb-4">
                        <Card.Img variant="top" src="/images/SAS-QI.png" />
                        <Card.Body>
                            <Card.Title>AHRQ QI Software</Card.Title>
                            <Link
                                className="btn btn-primary"
                                role="button"
                                to="/software"
                            >
                                Learn More
                            </Link>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={6}  className='stretchCard'>
                    <Card className="mb-4">
                        <Card.Img variant="top" src="/images/QI-CaseStudies.jpeg" />
                        <Card.Body>
                            <Card.Title>AHRQ QI Case Studies</Card.Title>
                            <Link
                                className="btn btn-primary"
                                role="button"
                                to="/resources/case_studies"
                            >
                                Learn More
                            </Link>
                        </Card.Body>
                    </Card>
                </Col>

                <Col  xs={12} md={6} className='stretchCard'>
                    <Card className="mb-4">
                        <Card.Img variant="top" src="/images/QI-News.jpeg" />
                        <Card.Body>
                            <Card.Title>AHRQ QI News</Card.Title>
                            <Link
                                className="btn btn-primary"
                                role="button"
                                to="/news"
                            >
                                Learn More
                            </Link>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={6}  className='stretchCard'>
                    <Card className="mb-4">
                        <Card.Img variant="top" src="/images/QI-Toolkits.jpeg" />
                        <Card.Body>
                            <Card.Title>AHRQ QI Hospital Toolkits</Card.Title>
                            <Link
                                className="btn btn-primary"
                                role="button"
                                to="/resources/toolkits"
                            >
                                Learn More
                            </Link>
                        </Card.Body>
                    </Card>
                </Col>

                <Col  xs={12} md={6} className='stretchCard'>
                    <Card className="mb-4">
                        <Card.Img variant="top" src="/images/QI-Resources.jpeg" />
                        <Card.Body>
                            <Card.Title>AHRQ QI Resources</Card.Title>
                            <Link
                                className="btn btn-primary"
                                role="button"
                                to="/measures/qi_resources"
                            >
                                Learn More
                            </Link>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={6}  className='stretchCard'>
                    <Card className="mb-4">
                        <Card.Img variant="top" src="/images/QI-ContactUs.jpg" />
                        <Card.Body>
                            <Card.Title>Contact Us</Card.Title>
                            <Link
                                className="btn btn-primary"
                                role="button"
                                to="/home/contact"
                            >
                                Learn More
                            </Link>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </>)
}

export default AboutUs;